import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Icon, MaskedLink } from '@hz-design-system/web-ui';
import React from 'react';
import Classes from '../ProfileSidebar.scss';

const WebsiteUrl = ({ url }: { url: string }) => {
  const i18n = useI18nContext();
  return (
    <li className={Classes.infoWrap}>
      <Icon name="website" />
      <MaskedLink href={url} className={Classes['infoWrap-link']} target="_blank" rel="noopener noreferrer">
        {i18n.t('sellerProfile.websiteUrl.label')}
      </MaskedLink>
    </li>
  );
};

export default WebsiteUrl;
